import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed7e92fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-aq" }
const _hoisted_2 = {
  key: 0,
  class: "nge-aq-head"
}
const _hoisted_3 = { class: "nge-aq-titlerow" }
const _hoisted_4 = { class: "nge-aq-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-aq-info-i",
  "aria-hidden": "true"
}, "i", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-aq-info-word" }, "Instructions", -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "nge-aq-help"
}
const _hoisted_9 = { class: "nge-aq-help-head" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "How to do a Cilia Quest", -1 /* HOISTED */))
const _hoisted_11 = {
  key: 1,
  class: "nge-aq-headrow"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "nge-aq-tally",
  title: "Cells you have submitted on this quest"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 1,
  class: "nge-aq-empty"
}
const _hoisted_16 = {
  key: 0,
  class: "nge-aq-error"
}
const _hoisted_17 = {
  key: 1,
  class: "nge-aq-empty"
}
const _hoisted_18 = {
  key: 0,
  class: "nge-aq-empty nge-aq-empty--tight"
}
const _hoisted_19 = {
  key: 0,
  class: "nge-aq-section"
}
const _hoisted_20 = { class: "nge-aq-row-left" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-aq-pip nge-aq-pip--claimed" }, null, -1 /* HOISTED */))
const _hoisted_22 = { class: "nge-aq-row-info" }
const _hoisted_23 = { class: "nge-aq-row-name" }
const _hoisted_24 = {
  key: 0,
  class: "nge-aq-active-pill",
  title: "The quest you are working on"
}
const _hoisted_25 = {
  class: "nge-aq-row-meta nge-aq-cellid",
  title: "This quest's cell, as the segment list shows it"
}
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = { class: "nge-aq-row-actions" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick", "title"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["disabled", "onClick"]
const _hoisted_32 = {
  key: 0,
  class: "nge-aq-form"
}
const _hoisted_33 = { class: "nge-aq-form-title" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-aq-form-label" }, "Cilium status", -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Choose one", -1 /* HOISTED */))
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 0,
  class: "nge-aq-status-hint"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-aq-form-label" }, "Cilium split or merged?", -1 /* HOISTED */))
const _hoisted_39 = { class: "nge-aq-pills" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-aq-form-label" }, "Notes", -1 /* HOISTED */))
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = { class: "nge-aq-form-actions" }
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = { class: "nge-aq-section" }
const _hoisted_46 = { class: "nge-aq-count" }
const _hoisted_47 = ["disabled", "title"]
const _hoisted_48 = {
  key: 0,
  class: "nge-aq-empty nge-aq-empty--tight"
}
const _hoisted_49 = { class: "nge-aq-row-left" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-aq-pip nge-aq-pip--available" }, null, -1 /* HOISTED */))
const _hoisted_51 = { class: "nge-aq-row-info" }
const _hoisted_52 = { class: "nge-aq-row-name" }
const _hoisted_53 = { class: "nge-aq-row-meta" }
const _hoisted_54 = { class: "nge-aq-row-actions" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["disabled", "onClick", "title"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-aq-section" }, "Taken", -1 /* HOISTED */))
const _hoisted_58 = { class: "nge-aq-row-left" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-aq-pip nge-aq-pip--claimed" }, null, -1 /* HOISTED */))
const _hoisted_60 = { class: "nge-aq-row-info" }
const _hoisted_61 = { class: "nge-aq-row-name" }
const _hoisted_62 = { class: "nge-aq-row-meta" }
const _hoisted_63 = { class: "nge-aq-row-actions" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "nge-aq-section" }
const _hoisted_66 = { class: "nge-aq-count" }
const _hoisted_67 = { class: "nge-aq-row-left" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-aq-pip nge-aq-pip--done" }, null, -1 /* HOISTED */))
const _hoisted_69 = { class: "nge-aq-row-info" }
const _hoisted_70 = { class: "nge-aq-row-name" }
const _hoisted_71 = { class: "nge-aq-row-meta" }
const _hoisted_72 = { class: "nge-aq-row-actions" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 0,
  class: "nge-aq-form"
}
const _hoisted_77 = { class: "nge-aq-form-title" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-aq-form-label" }, "Cilium status", -1 /* HOISTED */))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Choose one", -1 /* HOISTED */))
const _hoisted_80 = ["value"]
const _hoisted_81 = {
  key: 0,
  class: "nge-aq-status-hint"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-aq-form-label" }, "Cilium split or merged?", -1 /* HOISTED */))
const _hoisted_83 = { class: "nge-aq-pills" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-aq-form-label" }, "Notes", -1 /* HOISTED */))
const _hoisted_86 = ["disabled", "onClick"]
const _hoisted_87 = { class: "nge-aq-form-actions" }
const _hoisted_88 = ["disabled", "onClick"]
const _hoisted_89 = {
  key: 3,
  class: "nge-aq-empty"
}
const _hoisted_90 = {
  key: 4,
  class: "nge-aq-msg"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.slim)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString($setup.QUEST_TITLE), 1 /* TEXT */),
            _createElementVNode("button", {
              ref: "infoEl",
              class: _normalizeClass(["nge-aq-info", { 'nge-aq-info--open': $setup.showHelp, 'nge-aq-info--nudge': $setup.nudging }]),
              onClick: $setup.toggleHelp,
              title: "How to do a Cilia Quest"
            }, _hoisted_7, 2 /* CLASS */)
          ]),
          _createVNode($setup["EditableText"], {
            "text-key": "quest.retina_cilia.lead",
            original: $setup.QUEST_LEAD,
            "text-class": "nge-aq-lead",
            onAction: $setup.onQuestTextAction
          }, null, 8 /* PROPS */, ["original"]),
          ($setup.showHelp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("button", {
                    class: "nge-aq-help-close",
                    onClick: _cache[0] || (_cache[0] = $event => ($setup.showHelp = false)),
                    title: "Close"
                  }, "×")
                ]),
                _createVNode($setup["EditableText"], {
                  "text-key": "quest.retina_cilia.steps",
                  original: $setup.QUEST_STEPS,
                  "list-class": "nge-aq-help-steps",
                  onAction: $setup.onQuestTextAction
                })
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.backend.userId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "nge-aq-btn nge-aq-refresh",
                  disabled: $setup.loading,
                  onClick: $setup.load,
                  title: "Read the quest sheet again"
                }, _toDisplayString($setup.loading ? 'Reading…' : 'Refresh'), 9 /* TEXT, PROPS */, _hoisted_12),
                ($setup.rows.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createTextVNode("Submitted by you: "),
                      _createElementVNode("b", null, _toDisplayString($setup.mineDone), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.rows.length)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["nge-aq-tally", { 'nge-aq-tally--full': $setup.atLimit }]),
                      title: `You can hold ${$setup.QUEST_CLAIM_LIMIT} cells at a time`
                    }, [
                      _createTextVNode("Holding "),
                      _createElementVNode("b", null, _toDisplayString($setup.mine.length), 1 /* TEXT */),
                      _createTextVNode(" of " + _toDisplayString($setup.QUEST_CLAIM_LIMIT), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_14))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!$setup.backend.userId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Sign in to take a quest."))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          ($setup.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.error), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.loading && !$setup.rows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Reading the quest sheet…"))
            : ($setup.rows.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" Yours: taken, not yet submitted "),
                  ($props.slim && !$setup.mineShown.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, "No quest cell of yours yet. Open the full view to claim one."))
                    : _createCommentVNode("v-if", true),
                  ($setup.mineShown.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!$props.slim)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Yours"))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mineShown, (r) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: r.segmentId
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["nge-aq-row nge-aq-row--mine", { 'nge-aq-row--current': $setup.current === r.segmentId && !$setup.isActive(r), 'nge-aq-row--active': $setup.isActive(r) }])
                            }, [
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createTextVNode(_toDisplayString($setup.label(r)), 1 /* TEXT */),
                                    ($setup.isActive(r))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Active"))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_25, "Cell " + _toDisplayString(r.segmentId), 1 /* TEXT */),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["nge-aq-row-meta nge-aq-saved", { 'nge-aq-saved--bad': $setup.isActive(r) && !!$setup.questWork.error && $setup.questWork.saving !== r.segmentId }])
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString($setup.savedLine(r)), 1 /* TEXT */),
                                    ($setup.isActive(r))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "nge-aq-save",
                                          disabled: $setup.questWork.saving === r.segmentId,
                                          onClick: $event => ($setup.saveNow(r)),
                                          title: "Save your work on this quest now. It is also saved as you place annotations."
                                        }, "Save now", 8 /* PROPS */, _hoisted_26))
                                      : _createCommentVNode("v-if", true)
                                  ], 2 /* CLASS */)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                  class: "nge-aq-btn nge-aq-btn--jump",
                                  onClick: $event => ($setup.showOnly(r)),
                                  title: "Show only this cell and go to its soma"
                                }, "↗", 8 /* PROPS */, _hoisted_28),
                                _createElementVNode("button", {
                                  class: "nge-aq-btn",
                                  onClick: $event => ($setup.openCell(r)),
                                  title: $setup.isActive(r) ? 'Go to this cell. Your work stays as it is.' : 'Open this cell with your saved work, or its start view'
                                }, "Open", 8 /* PROPS */, _hoisted_29),
                                _createElementVNode("button", {
                                  class: _normalizeClass(["nge-aq-btn nge-aq-btn--submit", { 'nge-aq-btn--submit-open': $setup.open === r.segmentId }]),
                                  onClick: $event => ($setup.open === r.segmentId ? ($setup.open = '') : $setup.startSubmit(r)),
                                  title: "Submit this quest: your answer and a share link of this view go to the sheet"
                                }, "Submit", 10 /* CLASS, PROPS */, _hoisted_30),
                                _createElementVNode("button", {
                                  class: "nge-aq-btn nge-aq-btn--release",
                                  disabled: $setup.busy === r.segmentId,
                                  onClick: $event => ($setup.letGo(r)),
                                  title: "Take your name off this cell"
                                }, "Release", 8 /* PROPS */, _hoisted_31)
                              ])
                            ], 2 /* CLASS */),
                            ($setup.open === r.segmentId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, "Submit " + _toDisplayString(r.index || $setup.label(r)), 1 /* TEXT */),
                                  _hoisted_34,
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.form.status) = $event)),
                                    class: "nge-aq-select",
                                    onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                                    onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                                    onKeypress: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _hoisted_35,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.QUEST_STATUSES, (s) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: s,
                                        value: s
                                      }, _toDisplayString(s), 9 /* TEXT, PROPS */, _hoisted_36))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                    [_vModelSelect, $setup.form.status]
                                  ]),
                                  ($setup.statusHint)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString($setup.statusHint), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _hoisted_38,
                                  _createElementVNode("div", _hoisted_39, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.QUEST_SPLIT_MERGED, (s) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: s,
                                        class: _normalizeClass(["nge-aq-pill", { 'nge-aq-pill--on': $setup.form.splitMerged === s }]),
                                        onClick: $event => ($setup.form.splitMerged = $setup.form.splitMerged === s ? '' : s)
                                      }, _toDisplayString(s), 11 /* TEXT, CLASS, PROPS */, _hoisted_40))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  _hoisted_41,
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.form.notes) = $event)),
                                    class: "nge-aq-notes",
                                    rows: "2",
                                    placeholder: "Anything the reviewers should know",
                                    onKeydown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                                    onKeyup: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                                    onKeypress: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                    [_vModelText, $setup.form.notes]
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["nge-aq-form-msg", { 'nge-aq-form-msg--bad': !$setup.check.ok && !$setup.check.busy, 'nge-aq-form-msg--ok': $setup.check.ok }])
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString($setup.check.message), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                      class: "nge-aq-recheck",
                                      disabled: $setup.check.busy,
                                      onClick: $event => ($setup.recount(r)),
                                      title: "Check the crosshairs and count the annotation points again"
                                    }, "Check again", 8 /* PROPS */, _hoisted_42)
                                  ], 2 /* CLASS */),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["nge-aq-form-msg", { 'nge-aq-form-msg--bad': $setup.noPoints }])
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString($setup.pointsLine) + " The share link is made from the view as it is now.", 1 /* TEXT */)
                                  ], 2 /* CLASS */),
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("button", {
                                      class: "nge-aq-btn",
                                      onClick: _cache[9] || (_cache[9] = $event => ($setup.open = ''))
                                    }, "Not now"),
                                    _createElementVNode("button", {
                                      class: "nge-aq-btn nge-aq-btn--send",
                                      disabled: !$setup.form.status || !$setup.check.ok || $setup.busy === r.segmentId,
                                      onClick: $event => ($setup.send(r, $event))
                                    }, _toDisplayString($setup.busy === r.segmentId ? 'Submitting…' : 'Submit'), 9 /* TEXT, PROPS */, _hoisted_44)
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (!$props.slim)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createCommentVNode(" Open: nobody's yet "),
                        _createElementVNode("div", _hoisted_45, [
                          _createTextVNode("Open "),
                          _createElementVNode("span", _hoisted_46, _toDisplayString($setup.available.length), 1 /* TEXT */),
                          ($setup.nextRoom > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "nge-aq-btn nge-aq-btn--take nge-aq-btn--next",
                                disabled: !!$setup.busy,
                                onClick: $setup.takeNext,
                                title: `Claim the next ${$setup.nextRoom === 1 ? 'open cell' : $setup.nextRoom + ' open cells'} in the list. The first one opens.`
                              }, _toDisplayString($setup.busy === 'next' ? 'Claiming…' : `Claim next ${$setup.nextRoom}`), 9 /* TEXT, PROPS */, _hoisted_47))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (!$setup.available.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Every cell is taken or done."))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.available, (r) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: r.segmentId,
                            class: _normalizeClass(["nge-aq-row", { 'nge-aq-row--current': $setup.current === r.segmentId }])
                          }, [
                            _createElementVNode("div", _hoisted_49, [
                              _hoisted_50,
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, _toDisplayString($setup.label(r)), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_53, _toDisplayString(r.soma ? 'Soma at ' + r.soma : 'Open'), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("button", {
                                class: "nge-aq-btn nge-aq-btn--jump",
                                onClick: $event => ($setup.showOnly(r)),
                                title: "Show only this cell and go to its soma"
                              }, "↗", 8 /* PROPS */, _hoisted_55),
                              _createElementVNode("button", {
                                class: "nge-aq-btn nge-aq-btn--take",
                                disabled: $setup.busy === r.segmentId || !!$setup.busy || $setup.atLimit,
                                onClick: $event => ($setup.take(r)),
                                title: $setup.atLimit ? `You hold ${$setup.QUEST_CLAIM_LIMIT} quests already. Submit or release one first.` : 'Put your name on this cell and open its start view'
                              }, _toDisplayString($setup.busy === r.segmentId ? 'Claiming…' : 'Claim'), 9 /* TEXT, PROPS */, _hoisted_56)
                            ])
                          ], 2 /* CLASS */))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createCommentVNode(" Taken by others "),
                        ($setup.taken.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_57,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.taken, (r) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: r.segmentId,
                                  class: _normalizeClass(["nge-aq-row nge-aq-row--dim", { 'nge-aq-row--current': $setup.current === r.segmentId }])
                                }, [
                                  _createElementVNode("div", _hoisted_58, [
                                    _hoisted_59,
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("div", _hoisted_61, _toDisplayString($setup.label(r)), 1 /* TEXT */),
                                      _createElementVNode("div", _hoisted_62, _toDisplayString(r.annotator), 1 /* TEXT */)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("button", {
                                      class: "nge-aq-btn nge-aq-btn--jump",
                                      onClick: $event => ($setup.showOnly(r)),
                                      title: "Show only this cell and go to its soma"
                                    }, "↗", 8 /* PROPS */, _hoisted_64)
                                  ])
                                ], 2 /* CLASS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Submitted "),
                        ($setup.done.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_65, [
                                _createTextVNode("Submitted "),
                                _createElementVNode("span", _hoisted_66, _toDisplayString($setup.done.length), 1 /* TEXT */)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.done, (r) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: r.segmentId
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["nge-aq-row nge-aq-row--done", { 'nge-aq-row--mine': $setup.isMine(r), 'nge-aq-row--current': $setup.current === r.segmentId }])
                                  }, [
                                    _createElementVNode("div", _hoisted_67, [
                                      _hoisted_68,
                                      _createElementVNode("div", _hoisted_69, [
                                        _createElementVNode("div", _hoisted_70, _toDisplayString($setup.label(r)), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_71, _toDisplayString(r.status) + _toDisplayString(r.annotator ? ', ' + ($setup.isMine(r) ? 'you' : r.annotator) : '') + _toDisplayString(r.date ? ', ' + r.date : ''), 1 /* TEXT */)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_72, [
                                      _createElementVNode("button", {
                                        class: "nge-aq-btn nge-aq-btn--jump",
                                        onClick: $event => ($setup.showOnly(r)),
                                        title: "Show only this cell and go to its soma"
                                      }, "↗", 8 /* PROPS */, _hoisted_73),
                                      _createElementVNode("button", {
                                        class: "nge-aq-btn",
                                        onClick: $event => ($setup.viewDone(r)),
                                        title: "Open the submitted view"
                                      }, "View", 8 /* PROPS */, _hoisted_74),
                                      ($setup.isMine(r))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: _normalizeClass(["nge-aq-btn nge-aq-btn--submit", { 'nge-aq-btn--submit-open': $setup.open === r.segmentId }]),
                                            onClick: $event => ($setup.open === r.segmentId ? ($setup.open = '') : $setup.startSubmit(r)),
                                            title: "Submit this cell again with a new answer"
                                          }, "Again", 10 /* CLASS, PROPS */, _hoisted_75))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ], 2 /* CLASS */),
                                  ($setup.open === r.segmentId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                        _createElementVNode("div", _hoisted_77, "Submit " + _toDisplayString(r.index || $setup.label(r)) + " again", 1 /* TEXT */),
                                        _hoisted_78,
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.form.status) = $event)),
                                          class: "nge-aq-select",
                                          onKeydown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                                          onKeyup: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                                          onKeypress: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                                        }, [
                                          _hoisted_79,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.QUEST_STATUSES, (s) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: s,
                                              value: s
                                            }, _toDisplayString(s), 9 /* TEXT, PROPS */, _hoisted_80))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                          [_vModelSelect, $setup.form.status]
                                        ]),
                                        ($setup.statusHint)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString($setup.statusHint), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _hoisted_82,
                                        _createElementVNode("div", _hoisted_83, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.QUEST_SPLIT_MERGED, (s) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: s,
                                              class: _normalizeClass(["nge-aq-pill", { 'nge-aq-pill--on': $setup.form.splitMerged === s }]),
                                              onClick: $event => ($setup.form.splitMerged = $setup.form.splitMerged === s ? '' : s)
                                            }, _toDisplayString(s), 11 /* TEXT, CLASS, PROPS */, _hoisted_84))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _hoisted_85,
                                        _withDirectives(_createElementVNode("textarea", {
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.form.notes) = $event)),
                                          class: "nge-aq-notes",
                                          rows: "2",
                                          placeholder: "Anything the reviewers should know",
                                          onKeydown: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                                          onKeyup: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                                          onKeypress: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                          [_vModelText, $setup.form.notes]
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["nge-aq-form-msg", { 'nge-aq-form-msg--bad': !$setup.check.ok && !$setup.check.busy, 'nge-aq-form-msg--ok': $setup.check.ok }])
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString($setup.check.message), 1 /* TEXT */),
                                          _createElementVNode("button", {
                                            class: "nge-aq-recheck",
                                            disabled: $setup.check.busy,
                                            onClick: $event => ($setup.recount(r)),
                                            title: "Check the crosshairs and count the annotation points again"
                                          }, "Check again", 8 /* PROPS */, _hoisted_86)
                                        ], 2 /* CLASS */),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["nge-aq-form-msg", { 'nge-aq-form-msg--bad': $setup.noPoints }])
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString($setup.pointsLine) + " The share link is made from the view as it is now.", 1 /* TEXT */)
                                        ], 2 /* CLASS */),
                                        _createElementVNode("div", _hoisted_87, [
                                          _createElementVNode("button", {
                                            class: "nge-aq-btn",
                                            onClick: _cache[18] || (_cache[18] = $event => ($setup.open = ''))
                                          }, "Not now"),
                                          _createElementVNode("button", {
                                            class: "nge-aq-btn nge-aq-btn--send",
                                            disabled: !$setup.form.status || !$setup.check.ok || $setup.busy === r.segmentId,
                                            onClick: $event => ($setup.send(r, $event))
                                          }, _toDisplayString($setup.busy === r.segmentId ? 'Submitting…' : 'Submit'), 9 /* TEXT, PROPS */, _hoisted_88)
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : (!$setup.loading && !$setup.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, "The quest sheet has no cells yet."))
                : _createCommentVNode("v-if", true),
          ($setup.message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString($setup.message), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}